"use client";

import { useState } from "react";
import { FavoriteBorder, Favorite } from "@mui/icons-material";
import { IconButton, Snackbar, Alert, Tooltip, useMediaQuery } from "@mui/material";

export default function AddToFavourite({ product, onClickEvent }) {
  const { id } = product;
  const [isLoading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [saved, setSaved] = useState(false);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("lg"));

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  const handleClick = async () => {
    try {
      setLoading(true);
      const ds = await onClickEvent(id);
      setMessage(ds.message);
      setSaved((prev) => !prev);
      setOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Tooltip title={saved ? "Quitar de favoritos" : "Añadir a favoritos"} placement="top">
        <IconButton
          onClick={handleClick}
          disabled={isLoading}
          sx={{
            flexShrink: 0,
            width: 40,
            height: 40,
            border: "1px solid",
            borderColor: saved ? "error.main" : "grey.300",
            color: saved ? "error.main" : "text.secondary",
            borderRadius: 2,
            transition: "all 0.2s",
            "&:hover": {
              borderColor: "error.main",
              color: "error.main",
              backgroundColor: "error.50",
            },
          }}
        >
          {saved ? <Favorite fontSize="small" /> : <FavoriteBorder fontSize="small" />}
        </IconButton>
      </Tooltip>

      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: !isMobile ? "top" : "bottom", horizontal: "center" }}
      >
        <Alert
          color="primary"
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </>
  );
}
